import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { forgotPassword } from './actions';
import ForgottenPasswordForm from './ForgottenPasswordForm';
import { Redirect } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { withNamespaces } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import { FORGOTTEN_PASSWORD_REQUEST, FORGOTTEN_PASSWORD_SUCCESS, FORGOTTEN_PASSWORD_FAILURE } from './actions';

class ForgottenPassword extends React.Component {

	render() {
		if (this.props.isAuthenticated) {
			const { from } = this.props.location.state || { from: { pathname: '/' } };
			return <Redirect to={from} />;
		}

		const { t, forgotPassword, passwordResetEmail } = this.props;

		return (
			<div className='franchise-portal'>
				<ReduxBlockUi block={FORGOTTEN_PASSWORD_REQUEST} unblock={[FORGOTTEN_PASSWORD_SUCCESS, FORGOTTEN_PASSWORD_FAILURE]}>
					<div className='box-login'>
						<h3>{t('FO_ForgottenPassword_Title')}</h3>
						<p>{t('FO_ForgottenPassword_Text')}</p>
						{passwordResetEmail && <Alert bsStyle='success'>{t('FO_ForgottenPassword_SubmitSuccess', { email: passwordResetEmail })}</Alert>}
						<ForgottenPasswordForm onSubmit={forgotPassword} />
					</div>
				</ReduxBlockUi>
			</div>
		);
	}
}

ForgottenPassword.propTypes = {
	forgotPassword: PropTypes.func,
	location: PropTypes.object,
	isAuthenticated: PropTypes.bool,
	errors: PropTypes.array,
	passwordResetEmail: PropTypes.string
};

const mapStateToProps = state => ({ ...state.auth });

export default connect(mapStateToProps, {
	forgotPassword
})(withNamespaces()(ForgottenPassword));